import { baseApi } from '../../api/baseApi';
export const partyServiceApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        validateIntegration: builder.query({
            query: ({ partyId }) => ({
                url: `/v1/party-service/integrations/${partyId}/validate`,
                headers: { 'x-tr-party-selected': partyId },
            }),
            transformResponse: (response) => {
                return response.result;
            },
            providesTags: (_result, _error, { partyId }) => [{ type: 'Integration', id: partyId }],
        }),
        getOrganizationOwnerContact: builder.query({
            query: ({ organizationId }) => ({
                url: `/v1/party-service/organization/${organizationId}/owner-contact`,
            }),
            transformResponse: (response) => response.result,
            providesTags: (_result, _error, { organizationId }) => [
                { type: 'Base', id: `organization-owner-contact-${organizationId}` },
            ],
        }),
        listOnvioClients: builder.query({
            query: ({ partyId, companyId }) => ({
                url: `/v1/party-service/integrations/${partyId}/onvio-clients`,
                params: { companyId },
                headers: { 'x-tr-party-selected': partyId },
            }),
            transformResponse: (response) => response.result,
            providesTags: (_result, _error, { partyId, companyId }) => [
                { type: 'Integration', id: `${partyId}-${companyId}-clients` },
            ],
        }),
        createOnvioIntegration: builder.mutation({
            query: ({ partyId, companyId, clientId }) => ({
                url: `/v1/party-service/integrations/${partyId}`,
                method: 'POST',
                body: { companyId, clientId },
                headers: { 'x-tr-party-selected': partyId },
            }),
            invalidatesTags: (_result, _error, { partyId }) => [{ type: 'Integration', id: partyId }],
        }),
    }),
    overrideExisting: false,
});
export const { useValidateIntegrationQuery, useLazyValidateIntegrationQuery, useGetOrganizationOwnerContactQuery, useLazyGetOrganizationOwnerContactQuery, useListOnvioClientsQuery, useLazyListOnvioClientsQuery, useCreateOnvioIntegrationMutation, } = partyServiceApi;
